<script>
import { pageCreationCompteProps, usePageCreationCompte } from "./mixin";
import InscriptionForm from "@/containers/compte-client/inscription-form";

export default {
  components: {
    InscriptionForm
  },
  props: {
    ...pageCreationCompteProps()
  },
  setup(props) {
    const { accountCreated } = usePageCreationCompte(props);
    return { accountCreated };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <InscriptionForm
      @showAuth="$showAuth()"
      @accountCreated="accountCreated"
      @magasinSwitched="accountCreated"
    />
  </div>
</template>
